/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowsSplit = createReactComponent("arrows-split", "IconArrowsSplit", [
  ["path", { d: "M21 17h-8l-3.5 -5h-6.5", key: "svg-0" }],
  ["path", { d: "M21 7h-8l-3.495 5", key: "svg-1" }],
  ["path", { d: "M18 10l3 -3l-3 -3", key: "svg-2" }],
  ["path", { d: "M18 20l3 -3l-3 -3", key: "svg-3" }]
]);

export { IconArrowsSplit as default };
//# sourceMappingURL=IconArrowsSplit.js.map
